import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { colors } from '../../styles/colors';
import { ZeeFontBold, ZeeFontRegular } from '../../styles/font';
import { scrollBarStyling } from '../../styles/styles';

export const HamburgerButton = styled.button`
  background-color: ${colors.PrimaryWhiteColorAlpha10};
  border: none;
  padding: 4px 6px;
  border-radius: 36px;
`;

export const HambugerMenuContainer = css`
  width: 360px;
  max-height: 80vh;
  overflow-y: auto;
  background: ${colors.AppBgColor};
  position: absolute;
  top: 80px;
  right: 0px;
  border-radius: 4px;

  /* width */
  ::-webkit-scrollbar {
    width: 4px;
    border-radius: 4px;
    background: ${colors.AccentScrollBarBg};
    opacity: 0.8;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    padding: 2px;
    background: ${colors.AccentScrollBarTrack};
    border-radius: 4px;
    opacity: 0.8;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: ${colors.AccentScrollBar};
    border-radius: 4px;
    opacity: 0.8;
  }

  ${ZeeFontBold(14, 18)}
`;

export const HambugerMenuContainerMobile = css`
  width: 100%;
  max-height: 80vh;
  overflow-y: auto;
  background: ${colors.AppBgColor};
  position: absolute;
  top: 0px;
  right: 0px;
  border-radius: 4px;

  ${scrollBarStyling()};

  ${ZeeFontBold(14, 18)}
`;

export const HamburgerMenuHeaderTitle = css`
  padding: 15.5px 16px;
  margin: 0px 16px;
  border-radius: 8px;
  color: ${colors.white};
  &:hover {
    background-color: ${colors.PrimaryWhiteColorAlpha05};
  }
`;

export const HamburgerMenuFooterTitle = css`
  ${ZeeFontRegular(12)};
  color: ${colors.PrimaryWhiteColorAlpha50};
  border-radius: 8px;
`;

export const activeItem = css`
  background-color: ${colors.PrimaryWhiteColorAlpha05};
`;
